export const ID58 = () => {
    return (
        <div>
            <div className="content" readonly=""><h1>TMS Логистика. Управление перевозками</h1>

                <p>
                    Отраслевое решение предназначено для компаний, которые в процессе осуществления своей деятельности
                    необходимо решение задач транспортной логистики. Такие
                    задачи включают в себя, помимо прочего, необходимость сопряженности участников транспортного
                    логистического процесса в следующих областях:
                </p>

                <ul>
                    <li>техническая сопряженность – требуется согласованность параметров различных типов транспортных
                        средств в цепочке перевозки;
                    </li>
                    <li>
                        технологическая сопряженность – применение единой технологии транспортировки, адаптированной для
                        всех видов транспорта, который задействован в цепочке
                        перевозки;
                    </li>
                    <li>экономическая сопряженность – общая технология построения тарифной системы в цепочке
                        перевозки.
                    </li>
                </ul>

                <p>Основное назначение решения – планирование грузоперевозок с использованием привлеченного
                    транспорта:</p>

                <ul>
                    <li>
                        <p>управление сборными (LTL - Less Truck Load) и комплектными&nbsp;(FTL- Full Truck Load)
                            перевозками грузов;</p>
                    </li>
                    <li>
                        <p>доставка "последней мили" (планирование городской доставки);</p>
                    </li>
                    <li>
                        <p>
                            управление мультимодальными перевозками грузов, обслуживаемых разными видами транспорта,
                            осуществляемых
                            мультимодальным&nbsp;транспортным&nbsp;оператором (MTO - Multimodal Transport
                            Operator),&nbsp; например,&nbsp;доставка грузов из Китая в Россию:
                            морской транспорт -&nbsp;железнодорожный транспорт -&nbsp;автомобильный транспорт;
                        </p>
                    </li>
                    <li>планирование цепочки транспортных логистических процессов совместно с различными подразделениями
                        компании;
                    </li>
                    <li>выбор исполнителя перевозки по каждому звену перевозки;</li>
                    <li>выбор вида перевозки: в отдельном ТС или в составе сборного груза;</li>
                    <li>автоматическое планирование региональной/местной доставки для большого количества заявок.</li>
                </ul>

                <p>Функциональность "1С:TMS Логистика. Управление перевозками" определяется следующим списком
                    подсистем:</p>
                <img src="https://cybernetica.kz/uploads/gallery/1953018145.png" alt="" srcSet=""/>

                <ul>
                    <li>управление нормативно‑справочной информацией;</li>
                    <li>управление потребностями в перевозке грузов;</li>
                    <li>управление заданиями на перевозку грузов;</li>
                    <li>автоматическое и ручное планирование маршрутов доставки;</li>
                    <li>формирование рейсов;</li>
                    <li>управление ресурсами для обеспечения рейсов;</li>
                    <li>контроль за выполнением рейсов;</li>
                    <li>управление тарифной политикой компании;</li>
                    <li>управление взаимодействиями;</li>
                    <li>управление доступом;</li>
                    <li>получение аналитической отчетности;</li>
                    <li>визуализация информации на электронных картах.</li>
                </ul>

                <p>В зависимости от структуры компании, в конфигурации могут быть настроены функциональные рабочие
                    места:</p>

                <ul>
                    <li>менеджера отдела продаж;</li>
                    <li>менеджера отдела закупок;</li>
                    <li>сотрудника отдела логистики;</li>
                    <li>сотрудника транспортного подразделения.</li>
                </ul>

                <h3>Управление нормативно‑справочной информацией</h3>
                <p>Подсистема обеспечивает работу всех остальных функциональных подсистем, в рамках которой создается,
                    обрабатывается и хранится следующая информация:</p>

                <ul>
                    <li>валюты и курсы валют;</li>
                    <li>организации (собственным юридическим лицам или индивидуальным предпринимателям);</li>
                    <li>деловые партнеры компании (агенты, перевозчики, заказчики и т.д.);</li>
                    <li>контактные лица, адреса;</li>
                    <li>правила тарификации, зависящие от параметров перевозки;</li>
                    <li>правила классификации грузов;</li>
                    <li>номенклатура;</li>
                    <li>пользователи;</li>
                    <li>группы тарифов;</li>
                    <li>маршруты.</li>
                </ul>

                <img src="https://cybernetica.kz/uploads/gallery/103316225.png" alt="" srcSet=""/>

                <h3>Управление потребностями в перевозке грузов</h3>
                <p>
                    Подсистема предоставляет пользователю возможность регистрации предварительной потребности в
                    перевозке грузов и контроля её последующей обработки. В
                    подсистеме реализованы следующие функции:
                </p>
                <ul>
                    <li>регистрация Потребности;</li>
                    <li>контроль обработки Потребности;</li>
                    <li>регистрация различного типа взаимодействий на основании текущей Потребности.</li>
                </ul>

                <img src="https://cybernetica.kz/uploads/gallery/226996264.png" alt="" srcSet=""/>

                <h3>Управление заданиями на перевозку грузов</h3>
                <p>
                    Подсистема предоставляет пользователю возможности регистрации Заданий на перевозку грузов и контроля
                    исполнения этих заданий. В подсистеме реализованы
                    следующие функции:
                </p>

                <ul>
                    <li>регистрация Заданий на перевозку грузов;</li>
                    <li>расчет плановой стоимости перевозки для клиента;</li>
                    <li>контроль исполнения Задания на перевозку груза;</li>
                    <li>регистрация различного типа взаимодействий на основании текущего Задания.</li>
                </ul>

                <img src="https://cybernetica.kz/uploads/gallery/619634172.png" alt="" srcSet=""/>

                <h3>Формирование рейсов</h3>
                <p>Подсистема предоставляет пользователю возможность автоматического и ручного формирования комплектных
                    и сборных Рейсов, причем:</p>

                <ul>
                    <li>в один Рейс могут быть включены звенья различных Заданий на перевозку грузов;</li>
                    <li>планирование затрат на выполнение Рейсов;</li>
                    <li>контроль исполнения Рейсов.</li>
                </ul>

                <img src="https://cybernetica.kz/uploads/gallery/1129245776.png" alt="" srcSet=""/>
                <img src="https://cybernetica.kz/uploads/gallery/1223758266.png" alt=""/>

                <p>
                    Для рейса можно сформировать пакет печатных форм, соответствующих требованиям законодательства при
                    осуществлении перевозок различными видами ТС по различным
                    направлениям.
                </p>

                <h3>Управление ресурсами для обеспечения рейсов</h3>
                <p>
                    Подсистема предоставляет пользователю возможность обработки заявок на выделение или поиск
                    транспортных средств и сотрудников для выполнения ранее
                    запланированных рейсов. В подсистеме реализованы следующие функции:
                </p>

                <ul>
                    <li>контроль потребностей в выделении ресурсов на выполнение рейсов и анализ заявок на выделение
                        транспортного средства;
                    </li>
                    <li>обработка заявок: подтверждение выделения транспортных средств и персонала на выполнение рейса
                        или отказ в удовлетворении заявки;
                    </li>
                    <li>возможность использования бизнес-процесса "Согласование подтверждения Заявки на ТС".</li>
                </ul>

                <img src="https://cybernetica.kz/uploads/gallery/368024816.png" alt="" srcSet=""/>

                <h3>Контроль выполнения рейсов</h3>
                <p>Подсистема позволяет фиксировать факт прохождения точек маршрута и осуществлять общий контроль за
                    процессом выполнения Рейсов.</p>
                <img src="https://cybernetica.kz/uploads/gallery/813296952.png" alt="" srcSet=""/>

                <h3>Управление тарифной политикой Компании</h3>
                <p>Подсистема предоставляет пользователю возможности фиксирования:</p>
                <ul>
                    <li>тарифной политики для услуг, оказываемых Компанией;</li>
                    <li>правил расчета собственных затрат.</li>
                </ul>

                <p>В подсистеме реализованы следующие функции:</p>
                <ul>
                    <li>фиксирование списка показателей расчета, зависящих от одного или двух параметров;</li>
                    <li>формирование правил расчета;</li>
                    <li>установка тарифов услуг и затрат в разрезе видов транспорта и групп тарификации.</li>
                </ul>

                <h3>Управление доступом</h3>
                <p>
                    Подсистема позволяет настраивать права доступа пользователей к различным объектам с помощью ролей.
                    Роль определяет, какие действия, над какими объектами
                    может выполнять пользователь, выступающий в этой роли. Каждому пользователю ставится в соответствие
                    одна или несколько ролей. Роли в конфигурации могут:
                </p>

                <ul>
                    <li>соответствовать должностям или видам деятельности различных пользователей;</li>
                    <li>соотноситься и с более мелкими функциями пользователя.</li>
                </ul>

                <img src="https://cybernetica.kz/uploads/gallery/1218643008.png" alt="" srcSet=""/>

                <h3>Получение аналитической отчетности</h3>
                <p>
                    Подсистема предоставляет пользователю возможность получения информации по оценке ключевых
                    показателей эффективности выполненных перевозок, и проведения
                    анализа статистических данных, наколенных в информационной базе с различной степенью детализации.
                    Вид представления отчетов может быть различным и
                    выбирается пользователем.
                </p>

                <img src="https://cybernetica.kz/uploads/gallery/1225321017.png" alt="" srcSet=""/>

                <h3>Визуализация информации на электронных карта</h3>
                <p>
                    Подсистема визуализации информации на электронных картах позволяет повысить удобство работы
                    диспетчера при составлении маршрута движения конкретного
                    транспортного средства. В случае отсутствия электронных карт, функции данной подсистемы не активны.
                </p>
                <ul>
                    <li>
                        OpenStreetMap – WEB картография, подходит для контроля фактических маршрутов (ГЛОНАСС мониторинг
                        доставки продукции), бесплатная картография. Работает
                        под ОС Windows и Linux.
                    </li>
                    <li>
                        ITOB:Картография – WEB картография для контроля формирования рейса, позволяет формировать
                        маршруты по правилам дорожного движения, подходит для всех
                        регионов. Работает под ОС Windows и Linux.
                    </li>
                </ul>

                <img src="https://cybernetica.kz/uploads/gallery/280041801.png" alt="" srcSet=""/>

                <p>
                    Данные карты в комплект поставки программного продукта не входят. Работа с картами ITOB:Картография
                    поддерживается при условии приобретения лицензий на
                    использование у соответствующих правообладателей. Вы можете самостоятельно выбрать любой из
                    предложенных картографических сервисов, исходя из потребностей
                    вашего предприятия и лицензионной политики правообладателя карт. В системах под управлением ОС Linux
                    имеются ограничения при работе с картами и
                    использовании функции автоматического планирования рейсов. Дополнительно за консультацией по выбору
                    картографического сервиса, условиям его приобретения и
                    наличию ограничений в использовании вы можете обратиться в компанию ITOB, по электронной почте
                    info@itob.ru. Подсистема предоставляет пользователю
                    возможности визуализировать на электронных картах:
                </p>
                <ul>
                    <li>географические адреса;</li>
                    <li>географические зоны;</li>
                    <li>автомобильные маршруты плановые;</li>
                    <li>автомобильные маршруты фактические;</li>
                </ul>
                <p>а также рассчитывать расстояние по указанному маршруту.</p>

                <h3>Интеграция с "1С:Центр спутникового мониторинга ГЛОНАСС/GPS"</h3>
                <p>
                    Совместное использование "1С:TMS" с "1С:Центр спутникового мониторинга ГЛОНАСС/GPS" расширит
                    функциональные возможности системы и позволит дополнительно в
                    режиме реального времени осуществлять мониторинг и контроль подвижных объектов, транспорта или
                    персонала:
                </p>

                <ul>
                    <li>контроль местоположения и фактического пробега объекта;</li>
                    <li>отчеты по фактическому расходу топлива, фиксация заправок и сливов топлива;</li>
                    <li>оповещения при наступлении различных событий;</li>
                    <li>пресечение отклонений от запланированных маршрутов;</li>
                    <li>получение сигнала от тревожной кнопки SOS для обеспечения безопасности перевозок;</li>
                    <li>контроль скоростного режима, превышения допустимой скорости;</li>
                    <li>контроль работы пеших сотрудников.</li>
                </ul>

                <img src="https://cybernetica.kz/uploads/gallery/358891669.png" alt="" srcSet=""/>

                <h3>Интеграция с мобильными устройствами на ОС Android</h3>
                <p>
                    Водителей или курьеров можно оснастить мобильными устройствами, работающими под управлением
                    операционной системы Android. Спланированные доставки из
                    "1C:TMS" могут быть переданы на мобильные устройства сотрудникам, которые принимают задание и
                    отражают статус о ходе его выполнения на каждом этапе. Таким
                    образом, диспетчер и логист в реальном времени могут контролировать факт выполнения заданий,
                    обмениваться текстовыми сообщениями, получать фото-отчёты и
                    контролировать траекторию движения объекта. К "1С:TMS" могут быть подключены различные мобильные
                    приложения. Первым таким работающим приложением является
                    "ITOB:Мобильный клиент" – бесплатное приложение производства компании "ITOB".
                </p>
                <img src="https://cybernetica.kz/uploads/gallery/1408806822.png" alt="" srcSet=""/>
                <img src="https://cybernetica.kz/uploads/gallery/918368260.png" alt=""/>

                <h3>Интеграция с сервисами для обмена сообщениями</h3>
                <p>
                    Для оперативного оповещения персонала транспортной компании о различных ситуациях при осуществлении
                    доставки грузов, реализована возможность получать на
                    мобильные телефоны сотрудников SMS, e-mail или Viber сообщения, например, о сходе с маршрута,
                    опозданиях к клиенту, задержках при выгрузке товара,
                    срабатывании тревожной кнопки SOS, изменение температурного режима доставки продукции и т.д. Так же
                    можно настроить информирование конечных клиентов о
                    времени получения товара.
                </p>

                <img src="https://cybernetica.kz/uploads/gallery/1311250789.png" alt=""/></div>
        </div>
    )
}